import * as types from "./mutation-types";

/**
 * Export all mutations
 */
export default {
  /**
   * @param state
   * @param payload
   */
  [types.SET_PARTNER](state, payload) {
    state.partner = payload;
  },
  /**
   * @param state
   * @param payload
   */
  [types.SET_PARAMETERS](state, payload) {
    state.parameters = payload;
  },
  /**
   * @param state
   * @param payload
   */
  [types.SET_CUSTOMER_SERVICE](state, payload) {
    state.customer_service = payload;
  },

  /**
   * TODO: https://app.clickup.com/t/868ck271k
   */
  [types.SET_USE_CUSTOM_LOGO](state, payload) {
    state.use_custom_logo = payload;
  },
};
